export enum SendAsEmailModalVariant {
  Invoice = 'invoice',
  Reminder = 'reminder',
}
